/** Копим ошибки страницы, чтобы приложить к замечанию «Идея / Проблема» (перенос из zakup.starec.ai). */
type Err = { at: string; text: string };
const errors: Err[] = [];
const push = (text: string) => {
  errors.push({ at: new Date().toISOString(), text: text.slice(0, 500) });
  if (errors.length > 20) errors.shift();
};
if (typeof window !== 'undefined') {
  window.addEventListener('error', (e) => push(`${e.message} @ ${e.filename}:${e.lineno}`));
  window.addEventListener('unhandledrejection', (e) => push(`unhandled: ${String((e as PromiseRejectionEvent).reason).slice(0, 300)}`));
  const origError = console.error.bind(console);
  console.error = (...args: unknown[]) => {
    push(args.map((a) => (typeof a === 'string' ? a : ((a as Error)?.message ?? JSON.stringify(a)))).join(' '));
    origError(...args);
  };
}
export function diagnosticsSnapshot(extra: Record<string, unknown> = {}) {
  return {
    url: location.href,
    viewport: `${innerWidth}×${innerHeight}`,
    dpr: devicePixelRatio,
    lang: navigator.language,
    online: navigator.onLine,
    errors: errors.slice(-10),
    at: new Date().toISOString(),
    ...extra,
  };
}
